<template>
    <span v-if="['STRIPE_CARTACREDITO'].includes(this.paymentMode)">
        {{$t('carrello_pag_carte')}}
    </span>
    <span v-else-if="this.paymentMode === 'PAYPAL'">
        PayPal
    </span>
    <span v-else>
        {{$t('contanti')}}
    </span>
</template>

<script>
export default {
    name: "IncOrderPaymentMode",
    props: ['paymentMode']
}
</script>
